import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { USER_KEY } from "../helper";
import PrivateRoute from "./PrivateRoute";
import Login from "../Screens/login/components/Login";
import CustomSideNav from "../Layout/SideNav";
import * as ROUTES from "./app";
import HomePage from "../Screens/home";
import ListUsers from "../Screens/users";
import NavBar from "../Layout/Navbar";
import CustomSetting from "./CustomSetting";
import MemberScreen from "../Screens/members";
import CatalogScreen from "../Screens/catalogs";
import SlideImageScreen from "../Screens/slideImage";
import CommunityScreen from "../Screens/community";
import VideoScreen from "../Screens/videos";
import Register from "../Screens/register";
import SummaryScore from "../summaryScore";
import FeedBackBranch from "../Screens/feedBackBranch";
import Employees_votes from "../Screens/employees_vote";
import ChatWithCustomer from "../chatwithcustomer";
import NotificationScreen from "../Screens/notification";
import WhatsAppScreen from "../Screens/whatsapp";

function AppRoutes() {
  const _local = localStorage.getItem(USER_KEY);

  return (
    <Router>
      {_local && <NavBar />}
      {_local ? (
        <>
          <CustomSideNav />
          <div className="main-content">
            <Routes>
              <Route path={ROUTES.HOME_PAGE} element={<PrivateRoute><HomePage /></PrivateRoute>} />
              <Route path={ROUTES.LIST_USERS} element={<PrivateRoute><ListUsers /></PrivateRoute>} />
              <Route path={ROUTES.LIST_MEMBER} element={<PrivateRoute><MemberScreen /></PrivateRoute>} />
              <Route path={ROUTES.LIST_CATEGORIES} element={<PrivateRoute><CatalogScreen /></PrivateRoute>} />
              <Route path={ROUTES.LIST_SLIDE_IMAGE} element={<PrivateRoute><SlideImageScreen /></PrivateRoute>} />
              <Route path={ROUTES.LIST_COMMUNITY} element={<PrivateRoute><CommunityScreen /></PrivateRoute>} />
              <Route path={ROUTES.LIST_VIDEOS} element={<PrivateRoute><VideoScreen /></PrivateRoute>} />
              <Route path={ROUTES.REGISTER} element={<PrivateRoute><Register /></PrivateRoute>} />
              <Route path={ROUTES.REPORT_FEEDBACK} element={<PrivateRoute><FeedBackBranch /></PrivateRoute>} />
              <Route path={ROUTES.SUMMARY_SCORE} element={<PrivateRoute><SummaryScore /></PrivateRoute>} />
              <Route path={ROUTES.EMPLOYEE_SCORE_VOTES} element={<PrivateRoute><Employees_votes /></PrivateRoute>} />
              <Route path={ROUTES.CHAT_WITH_CUSTOMER} element={<PrivateRoute><ChatWithCustomer /></PrivateRoute>} />
              <Route path={ROUTES.SEND_NOTIFICATION} element={<PrivateRoute><NotificationScreen /></PrivateRoute>} />
              <Route path={ROUTES.SEND_WHATSAPP} element={<PrivateRoute><WhatsAppScreen /></PrivateRoute>} />
              <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
          </div>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
      <CustomSetting />
    </Router>
  );
}

export default AppRoutes;
